// Use full path with a domain for static resources
// This is needed to resolve paths of dynamic imports
const environment = window.__ENV_CONFIG__ || {};

__webpack_public_path__ = environment.staticBaseUrl;
